import { CASCADE_CONNECTOR } from "../constants";
import { sha256 } from "./crypto";
export const genCascadeNodes = (nodes, keyMap, type = "key") => {
  nodes.forEach(cascade => {
    keyMap[cascade[type]] = cascade;
    if (Array.isArray(cascade.children) && cascade.children.length) {
      genCascadeNodes(cascade.children, keyMap, type);
    }
  });
};
export const genCascadeKeyMap = (cascadeNodes = []) => {
  let keyMap;
  if (Array.isArray(cascadeNodes)) {
    keyMap = {};
    genCascadeNodes(cascadeNodes, keyMap);
  }
  return keyMap || {};
};
export const genCascadeNodeRouteTitles = (nodes, routeTitleMap, routeTitle = "") => {
  nodes.forEach(cascade => {
    routeTitleMap[routeTitle.concat(cascade.title)] = cascade;
    if (Array.isArray(cascade.children) && cascade.children.length) {
      genCascadeNodeRouteTitles(cascade.children, routeTitleMap, routeTitle.concat(cascade.title, "/"));
    }
  });
};
export const genCascadeRouteTitleMap = prop => {
  let routeTitleMap;
  if (prop?.type === "cascade" && Array.isArray(prop.cascade?.nodes)) {
    routeTitleMap = {};
    genCascadeNodeRouteTitles(prop.cascade.nodes, routeTitleMap);
  }
  return routeTitleMap || {};
};
export const genCascadeRouteKeyMap = prop => {
  const keyMap = {};
  if (prop?.type === "cascade" && Array.isArray(prop.cascade?.nodes)) {
    genCascadeNodes(prop.cascade.nodes, keyMap, "routeKey");
  }
  return keyMap;
};
export const addCascadeNode = async (originalProp, cascadeAdd, nodesMap, routeTitlesMap) => {
  const route = cascadeAdd.split("/");
  let parentNode = null,
    addKey = "";
  const cascade = originalProp.cascade ? JSON.parse(JSON.stringify(originalProp.cascade)) : {
    nodes: [],
    nodesMap: {},
    titles: []
  };
  for (let i = 0; i < route.length; i++) {
    if (parentNode) {
      if (Array.isArray(parentNode.children) && parentNode.children.length) {
        let parent = parentNode.children.find(x => x.title === route[i]);
        if (!parent) break;
        parentNode = parent;
        route.splice(0, 1);
        i--;
      } else {
        break;
      }
    } else {
      let parent = cascade.nodes.find(x => x.title === route[i]);
      if (!parent) break;
      parentNode = parent;
      route.splice(0, 1);
      i--;
    }
  }
  const findNodePath = (node, routes, nMap) => {
    if (node.parentKey) {
      const parent = nMap[node.parentKey];
      if (parent) {
        routes.push(parent.title);
        findNodePath(parent, routes, nMap);
      }
    }
  };
  if (route.length) {
    if (!parentNode) {
      if (!route[0]) return [cascade, addKey];
      const key = "0-".concat(await sha256(route[0]));
      if (nodesMap[key]) return [cascade, addKey];
      parentNode = {
        key: key,
        routeKey: "1-".concat(await sha256(route[0].concat(CASCADE_CONNECTOR))),
        title: route[0],
        children: []
      };
      cascade.nodes.push(parentNode);
      nodesMap[key] = parentNode;
      routeTitlesMap[route[0]] = parentNode;
      if (!cascade.titles.length) cascade.titles.push("第1级");
      route.splice(0, 1);
      addKey = key;
    }
    if (route.length) {
      for (let index = 0; index < route.length; index++) {
        const title = route[index];
        if (!title) break;
        if (!parentNode.children) parentNode.children = [];
        const routes = [parentNode.title];
        findNodePath(parentNode, routes, nodesMap);
        const levelPre = (routes.length + 1).toString().concat("-");
        const ck = "0-".concat(await sha256(routes.reverse().join(CASCADE_CONNECTOR).concat(CASCADE_CONNECTOR, title)));
        if (nodesMap[ck]) break;
        const newNode = {
          key: ck,
          routeKey: levelPre.concat(await sha256(routes.reverse().join(CASCADE_CONNECTOR).concat(CASCADE_CONNECTOR, title, CASCADE_CONNECTOR))),
          title: title,
          parentKey: parentNode.key,
          children: []
        };
        parentNode.children.push(newNode);
        nodesMap[ck] = newNode;
        routeTitlesMap[routes.reverse().join("/").concat("/", title)] = newNode;
        if (cascade.titles.length < routes.length + 1) cascade.titles.push(`第${routes.length + 1}级`);
        parentNode = newNode;
        addKey = ck;
      }
    }
  }
  return [cascade, addKey, nodesMap, routeTitlesMap];
};
export const genRouteTitle = (key, nodesMap) => {
  const routes = [];
  function genParentKey(ck) {
    const parent = nodesMap[ck];
    if (parent.parentKey) {
      genParentKey(parent.parentKey);
    }
    routes.push(parent.title);
  }
  genParentKey(key);
  return routes;
};
export const displayCascadeValue = props => {
  const {
    value,
    rArr = true,
    forceRoutes = true,
    cascadeNodes = [],
    cascadeMap = null,
    multiple = false,
    hideRoutes = false
  } = props;
  if (!value || !value.length) return [];
  const display = [];
  let isInvalid = false;
  if (Array.isArray(value) && cascadeNodes) {
    // remove routeKey
    const valueKeys = value.filter(i => i[0] === "0");
    const nodesMap = cascadeMap ? cascadeMap : genCascadeKeyMap(cascadeNodes);
    if (multiple) {
      valueKeys.forEach(v => {
        if (nodesMap[v]) {
          if (hideRoutes && !forceRoutes) {
            display.push(nodesMap[v].title);
          } else {
            const routes = genRouteTitle(v, nodesMap);
            display.push(rArr ? routes : routes.join(" / "));
          }
        } else {
          isInvalid = true;
        }
      });
    } else {
      const first = value.find(v => nodesMap[v]);
      if (first) {
        if (hideRoutes && !forceRoutes) {
          display.push(nodesMap[first].title);
        } else {
          const routes = genRouteTitle(first, nodesMap);
          display.push(rArr ? routes : routes.join(" / "));
        }
      } else {
        isInvalid = true;
      }
    }
  }
  if (isInvalid) {
    return ["无效配置，请重新选择"];
  }
  return display;
};